import mori from 'mori';
import { appDefault } from '../../config/config';
import sortComparator from '../table/sortComparator';

/**
 * Sort the rows
 * @param  {String} options.colId: sortedKey      [the sort key of the column]
 * @param  {String} options.sort                  [the sort direction]
 * @param  {mori.vector} rows                     [the rows]
 * @param  {mori.vector} headers                  [the immutable headers]
 * @param  {string} dataType                      [combinedFilters[3].type (active datatype)]
 * @param  {string} baseColumn                    [text for first column]
 * @param  {string} isGeoMulti                    [whether this is a multi-geo indicator]
 * @return {mori.vector}                          [the sorted rows]
 */
export default function sortRows(
  { colId: sortedKey = 'Location', sort = 'asc' },
  rows,
  headers,
  dataType,
  baseColumn,
  isGeoMulti
) {
  const [
    characteristic,
    headerGroup = false,
  ] = sortedKey.split('__').reverse();

  // Get the sort column (there should only be one...) and convert it to JS
  const sortColumn = mori.toJs(mori.first(mori.filter(
    (col) => (
      !dataType ||
        (mori.get(col, 'type') === 'geography' ||
          mori.get(col, 'type') === dataType)) &&
    ((mori.get(col, 'headerGroup') === headerGroup &&
      mori.get(col, 'characteristic') === characteristic) ||
        mori.get(col, 'characteristic') === characteristic
    ),
    headers
  ))) || {}; // handle null case for sortcolumn

  const isInverted = appDefault.descSortFirst
    .indexOf(sortColumn.type) >= 0 ?
      sort === 'asc' :
      sort === 'desc';

  const comparator = sortComparator(
    sortColumn,
    baseColumn,
    isGeoMulti ? baseColumn : null
  );

  // sortComparator is a factory function
  // let comparator = sortComparator(
  //   sortColumn,
  //   'Location',
  //   null
  // );
  // Check for geomulti tables (use 'State' instead of 'Location')
  // if (
    // and this is why nested immutables are occasionally annoying... sorry
  //   mori.first(mori.first(mori.first(mori.first(mori.last(mori.first(rows))))))
  //     === 'State'
  // ) {
  //   comparator = sortComparator(
  //     sortColumn,
  //     'State',
  //     'State'
  //   );
  // }

  return mori.map(
    (sheet) => mori.vector(
      mori.first(sheet),
      mori.sortBy(
        (row) => mori.vector(
          mori.get(row, mori.set(
            sortColumn.headerGroup ?
              [
                sortColumn.headerGroup,
                sortColumn.characteristic,
                sortColumn.label,
              ] :
              [
                sortColumn.characteristic,
                sortColumn.label,
              ]
          )),
          (
            mori.get(row, mori.set(['Location', 'Geography']), false) ||
            mori.get(row, mori.set(['State', 'Geography']))
          )
        ),
        (a, b) => {
          // We need to check for wrapups... because
          // comparator is not doing it...
          // and we always need to push wrapups to the top
          if (sortColumn.type === 'geography') {
            if (
              appDefault.specialWrapups.indexOf(mori.first(a)) > -1 &&
              appDefault.specialWrapups.indexOf(mori.first(b)) === -1
            ) {
              return -1;
            } else if (
              appDefault.specialWrapups.indexOf(mori.first(a)) === -1 &&
              appDefault.specialWrapups.indexOf(mori.first(b)) > -1
            ) {
              return 1;
            }
          }
          // Now once that's over we can sort normally...
          // If you notice `Location` & `State` have the same value,
          // that's fine, the reason we don't just use one
          // (and adjust the comparator) is we are trying to keep it
          // as close to the table sort as possible, and if we
          // just used multiple comparator() funcs to swap between geomutli
          // and not, it would be lots of duplicate code
          return comparator(
            { text: mori.first(a) },
            { text: mori.first(b) },
            { data: {
              Location: mori.first(mori.rest(a)),
              State: mori.first(mori.rest(a)),
              isSummary: appDefault.isSummaryRow.test(a) || null,
            } },
            { data: {
              Location: mori.first(mori.rest(b)),
              State: mori.first(mori.rest(b)),
              isSummary: appDefault.isSummaryRow.test(b) || null,
            } },
            // Weird inverted/anti invert logic... I'm sorry
            (appDefault.descSortFirst.indexOf(sortColumn.type) >= 0) ?
              !isInverted :
              isInverted
          ) * (
            // What follows is even more weird invert logic...
            // this was a big headache, again I'm sorry
            (
              (isInverted &&
                // Because Geos don't actually sort...
                (sortColumn.type === 'geography' ||
                  sortColumn.type === 'text')
              ) ||
              (!isInverted &&
                appDefault.descSortFirst.indexOf(sortColumn.type) >= 0)
            ) ? -1 : 1
          );
        },
        mori.flatten(mori.rest(sheet))
      )
    ),
    rows
  );
}



// WEBPACK FOOTER //
// ../datacenter/app/js/services/getFootnotes/sortRows.js